import React from 'react'
import { setPropTypes, PropTypes } from 'proper-types'
import * as R from 'ramda'
import { connect } from 'react-redux'
import { selectors as i18nSelectors, translator } from 'mage-i18n'
import moment from 'moment-timezone'
import { DateRangeField } from 'mage-deps/@klarna/bubble-ui'

class DateRangePickerBUI extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      currentYear: moment().format('YYYY'),
      monthCurrentlyShown: moment().format('YYYY-MM'),
      open: false
    }
  }

  onToggle () {
    this.setState({ open: !this.state.open })
  }

  onGoToNextMonth () {
    const monthCurrentlyShown = moment(this.state.monthCurrentlyShown, 'YYYY-MM')
      .add(1, 'months')
      .format('YYYY-MM')

    this.setState({
      monthCurrentlyShown
    })
  }

  onGoToPreviousMonth () {
    const monthCurrentlyShown = moment(this.state.monthCurrentlyShown, 'YYYY-MM')
      .subtract(1, 'months')
      .format('YYYY-MM')

    this.setState({
      monthCurrentlyShown
    })
  }

  render () {
    const {
      /* eslint-disable react/prop-types */
      id,
      t,
      label,
      presets,
      onChange,
      isClearable,
      range,
      formatter,
      disableDatesHandler
      /* eslint-enable react/prop-types */
    } = this.props

    return (
      <DateRangeField
        id={id}
        monthNames={[
          t('core.dateRangePicker.months.january'),
          t('core.dateRangePicker.months.february'),
          t('core.dateRangePicker.months.march'),
          t('core.dateRangePicker.months.april'),
          t('core.dateRangePicker.months.may'),
          t('core.dateRangePicker.months.june'),
          t('core.dateRangePicker.months.july'),
          t('core.dateRangePicker.months.august'),
          t('core.dateRangePicker.months.september'),
          t('core.dateRangePicker.months.october'),
          t('core.dateRangePicker.months.november'),
          t('core.dateRangePicker.months.december')
        ]}
        weekDayOneLetterNames={{
          monday: t('core.dateRangePicker.weekDaysShort.monday'),
          tuesday: t('core.dateRangePicker.weekDaysShort.tuesday'),
          wednesday: t('core.dateRangePicker.weekDaysShort.wednesday'),
          thursday: t('core.dateRangePicker.weekDaysShort.thursday'),
          friday: t('core.dateRangePicker.weekDaysShort.friday'),
          saturday: t('core.dateRangePicker.weekDaysShort.saturday'),
          sunday: t('core.dateRangePicker.weekDaysShort.sunday')
        }}
        currentYear={this.state.currentYear}
        monthCurrentlyShown={this.state.monthCurrentlyShown}
        onGoToPreviousMonth={() => this.onGoToPreviousMonth()}
        onGoToNextMonth={() => this.onGoToNextMonth()}
        onChange={onChange}
        disableDatesHandler={disableDatesHandler}
        onToggle={() => this.onToggle()}
        formatter={(value) => formatter(moment(value))}
        isClearable={isClearable}
        isExpanded={this.state.open}
        startDateLabel={t('core.dateRangePicker.startLabel')}
        endDateLabel={t('core.dateRangePicker.endLabel')}
        label={label}
        presets={presets}
        range={range}
      />
    )
  }
}

DateRangePickerBUI.defaultProps = {
  isClearable: true
}

const EnhancedDateRangePickerBUI = R.compose(
  setPropTypes({
    id: PropTypes.string,
    t: PropTypes.func,
    label: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    isClearable: PropTypes.bool,
    range: PropTypes.array.isRequired,
    formatter: PropTypes.func,
    disableDatesHandler: PropTypes.func
  }),
  connect(
    state => ({
      t: translator(state),
      formatter: i18nSelectors.formatters.date(state).format
    })
  )
)(DateRangePickerBUI)

EnhancedDateRangePickerBUI.displayName = 'DateRangePicker'

export default EnhancedDateRangePickerBUI

export {
  DateRangePickerBUI
}
